export default "__VITE_ASSET__DowbATQS__"